import { render, staticRenderFns } from "./BattleyeR2New.vue?vue&type=template&id=21243bd3&scoped=true"
import script from "./BattleyeR2New.vue?vue&type=script&lang=ts"
export * from "./BattleyeR2New.vue?vue&type=script&lang=ts"
import style0 from "./BattleyeR2New.vue?vue&type=style&index=0&id=21243bd3&prod&lang=scss&scoped=true"
import style1 from "./BattleyeR2New.vue?vue&type=style&index=1&id=21243bd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21243bd3",
  null
  
)

export default component.exports